import { Link } from 'react-router'
import { SITE_NAME } from '#app/utils/branding.ts'
import { cn } from '#app/utils/misc.tsx'
import { type Route } from './+types/cancel.ts'

export const meta: Route.MetaFunction = () => [
	{ title: `Checkout Cancelled - ${SITE_NAME}` },
	{
		name: 'description',
		content:
			'Your checkout was cancelled. No charge was made and you can return to pricing anytime.',
	},
]

export default function CheckoutCancelRoute() {
	return (
		<main className="bg-cathedral-page min-h-screen px-6 py-16">
			<div className="mx-auto max-w-xl">
				<div className="text-center">
					<div className="mb-6 flex justify-center">
						<div className="border-muted bg-cathedral-surface-strong flex h-16 w-16 items-center justify-center rounded-full border-2">
							<svg
								className="text-cathedral-brown h-8 w-8"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth={2}
								aria-hidden="true"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</div>
					</div>

					<h1 className="cathedral-heading text-cathedral-dark text-3xl font-semibold tracking-wide">
						Checkout Cancelled
					</h1>

					<p className="cathedral-body text-cathedral-brown mt-4 text-lg leading-relaxed">
						Your payment was not completed. No charge has been made to your
						account.
					</p>

					<p className="cathedral-body text-cathedral-brown mt-2">
						You can return to the pricing page whenever you're ready to try
						again.
					</p>

					<div className="mt-8">
						<Link
							to="/pricing"
							className={cn(
								'inline-block w-full rounded-lg border-2 py-4 text-center',
								'cathedral-heading text-sm tracking-[0.15em] uppercase transition-all duration-300',
								'border-cathedral-gold text-cathedral-gold hover:bg-cathedral-bright hover:text-cathedral-deep',
							)}
						>
							Return to Pricing
						</Link>
					</div>

					<p className="cathedral-body text-cathedral-brown mt-6 text-sm">
						If you experienced any issues, please{' '}
						<a
							href="mailto:support@ikonexamen.com"
							className="hover:text-cathedral-gold underline"
						>
							contact support
						</a>
						.
					</p>
				</div>
			</div>
		</main>
	)
}

export function ErrorBoundary() {
	return (
		<main className="bg-cathedral-page min-h-screen px-6 py-16">
			<div className="mx-auto max-w-xl text-center">
				<h1 className="cathedral-heading text-cathedral-dark text-3xl font-semibold tracking-wide">
					Something went wrong
				</h1>
				<p className="cathedral-body text-cathedral-brown mt-4 text-lg">
					We couldn't load this page. Please try again.
				</p>
				<div className="mt-8">
					<Link
						to="/pricing"
						className={cn(
							'inline-block rounded-lg border-2 px-8 py-3',
							'cathedral-heading text-sm tracking-[0.15em] uppercase transition-all duration-300',
							'border-cathedral-gold text-cathedral-gold hover:bg-cathedral-bright hover:text-cathedral-deep',
						)}
					>
						View Pricing
					</Link>
				</div>
			</div>
		</main>
	)
}
